import PropTypes from "prop-types";
import styles from "./CategoryHtmlDescription.css";

const CategoryHtmlDescription = ({ description, testId }) => {
  if (!description) {
    return null;
  }

  return (
    <div className={styles.wrapper} data-testid={testId}>
      <div
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};

CategoryHtmlDescription.propTypes = {
  description: PropTypes.string,
  testId: PropTypes.string,
};

export default CategoryHtmlDescription;
